export default __webpack_public_path__ + "fdb34c0e90262cb0c571be6bbf4feabf.png";